import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Box,
  Container,
  Card,
  CardContent,
  Divider,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LockIcon from '@mui/icons-material/Lock';
import Page from '../../components/Layout/Page';
import Logo from '../../components/Layout/Logo';
import LoginForm from './LoginForm';
import AuthService from '../../services/authService';
import useStyles from './styles';
import { ReduxState } from '../../types';

function LoginView() {
  const classes = useStyles();
  const history = useHistory();
  const account = useSelector((state: ReduxState) => state.account);

  useEffect(() => {
    if (account?.user && AuthService.isAuthenticated()) {
      history.push('/alumnos');
    }
  }, [account.user]);

  return (
    <Page
      className={classes.root}
      title="Login"
    >
      <Container maxWidth="md">
        <Box
          mb={8}
          display="flex"
          alignItems="center"
          justifyContent='center'
        >
          <Logo className={classes.logo} />
        </Box>
        <Card className={classes.card}>
          <CardContent className={classes.content}>
            <Avatar className={classes.icon}>
              <LockIcon fontSize="large" />
            </Avatar>
            <Typography
              variant="h2"
              color="textPrimary"
            >
              <FormattedMessage
                id="login.title"
              />
            </Typography>
            <Typography
              variant="subtitle1"
              color="textPrimary"
            >
              <FormattedMessage
                id="login.subtitle"
              />
            </Typography>
            <Box mt={3}>
              <LoginForm />
            </Box>
            <Box my={2}>
              <Divider />
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default LoginView;
